export default {
  bind(el, binding) {
    const { value: loadMore } = binding;
    if (typeof loadMore === "function") {
      el.addEventListener("scroll", event => {
        const { scrollTop, clientHeight, scrollHeight } = event.target;
        if (scrollTop + clientHeight + 1 >= scrollHeight) {
          loadMore();
        }
      });
    }
  }
};
